
Greenmile.RouteProgress = Greenmile.RouteProgress || {};

Greenmile.RouteProgress.StaticData = {

    columns: [],

    defaultColumns: function () {

        var gridColumns = Monet.Grid.getGridLayout(App.Forms.RouteProgress.layout.index, 'RouteProgress');
        gridColumns.unshift({
            id: "routeStatusInfo",
            field: "routePercentage",
            width: 235,
            height: 95,
            name: Monet.I18n.getResourcesByKey('Filter.Route.status'),
            cssClass: "cell-row",
            sortable: true,
            resizable: false,
            formatter: function (_row, _cell, _value, _column, data) {

              if(data.model.attributes?.stopStats) {
                data.model.attributes.route = {
                  ...data.model.attributes.route,
                  route: data.model.attributes.route,
                  stopStats: data.model.attributes.stopStats
                };
              }

              return Greenmile.Utils.gridRouteProgressBar(data.model.attributes.route);
            }
        });

        return gridColumns;
    },

    dataMapper: {
        date: {
            type: "TEXT",
            lookupEntity: undefined
        },
        key: {
            type: "TEXT",
            lookupEntity: undefined
        }
    }
};
